module.exports = __webpack_public_path__ + "img/rocket-group.5e381e52.svg";